import ResetWatchDeviceModal from './ResetWatchDeviceModal'

export default ResetWatchDeviceModal
